// extracted by mini-css-extract-plugin
module.exports = {"information":"information__0OicLfPZ51A0x","icon":"icon__hx2p54S4kFGpY","text":"text__A3jZmL4OX-ppU","table_wrapper":"table_wrapper__pyyyhThIMGZnD"};